var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFC136"
    },
    d: "M256,0c-18.645,0-33.758,15.114-33.758,33.758v123.458h67.516V33.758C289.758,15.114,274.645,0,256,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDC3D"
    },
    d: "M423.34,202.831l28.875,219.429h-45.011l-22.247-219.429 c-8.316-82.078-62.081-145.566-127.415-146.556C342.534,57.029,412.526,120.607,423.34,202.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFA52E"
    },
    d: "M256,25.319c-4.661,0-8.44,3.778-8.44,8.44v33.758h16.879V33.758 C264.44,29.096,260.662,25.319,256,25.319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE777"
    },
    d: "M384.957,202.831l22.247,219.429H59.786L88.66,202.831C99.542,120.112,170.31,56.264,256,56.264 c0.518,0,1.035,0,1.542,0.011C322.875,57.265,376.641,120.753,384.957,202.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFA52E"
    },
    d: "M447.736,388.22h-33.758l33.758,67.517h33.758v-33.758 C481.494,403.411,466.303,388.22,447.736,388.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDC3D"
    },
    d: "M285.955,421.978l-28.683,90.011c41.118-0.45,76.946-22.967,96.2-56.252L285.955,421.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE777"
    },
    d: "M158.529,455.736l80.592-45.011l80.592,45.011c-12.513,33.106-35.75,55.555-62.441,56.252 C256.855,512,256.428,512,256,512C214.354,512,177.985,489.371,158.529,455.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFC136"
    },
    d: "M447.736,421.978v33.758H30.506v-33.758c0-18.567,15.191-33.758,33.758-33.758h349.713 C432.544,388.22,447.736,403.411,447.736,421.978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEDC3D"
    },
    cx: 310.812,
    cy: 180.325,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEDC3D"
    },
    cx: 355.823,
    cy: 202.831,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEDC3D"
    },
    cx: 156.177,
    cy: 315.358,
    r: 8.44
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubNotify);
export default __webpack_public_path__ + "static/media/sub-notify.348640423f336c6df5f424117d0a03a6.svg";
export { ForwardRef as ReactComponent };